import { affiliateApi } from '../lib/axios';

const BASE_URL = import.meta.env.VITE_API_URL || '';

interface BrandDetail {
  id: string;
  username: string;
  profileImage: string;
  firstName: string;
  lastName: string;
  email: string;
  companyName: string;
  website: string;
  country: string;
  description: string;
  timezone: string | null;
  sessionId: string;
  brandBannerImage: string;
  brandProfileImage: string;
  createdAt: string;
  updatedAt: string;
  onboardingStatus: string;
  otp: string | null;
  otpExpiry: string | null;
  revenueRank: number | null;
  commissionRank: number | null;
  ordersRank: number | null;
  affiliatesRank: number | null;
  overallRank: number | null;
}

interface Notification {
  id: string;
  title: string;
  message: string;
  suggestion?: string;
  tags?: string[];
  link?: string;
  read: boolean;
  userId: string;
  userType: string;
  brandDetailId: string | null;
  createdAt: string;
  updatedAt: string;
  brandDetail: BrandDetail | null;
}

interface ApiResponse<T> {
  data: T;
  pagination?: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export const notificationTempService = {
  async getNotifications(params: { page: number; limit: number; brandId?: string , programId?: string }): Promise<ApiResponse<Notification[]>> {
    const response = await affiliateApi.get(`${BASE_URL}/notifications`, { params });
    return response.data;
  },

  async markAsRead(id: string): Promise<ApiResponse<Notification>> {
    return affiliateApi.post(`${BASE_URL}/notifications/mark-read`, { id });
  },

  async markAllAsRead(): Promise<ApiResponse<{ success: boolean }>> {
    return affiliateApi.post(`${BASE_URL}/notifications/mark-all-read`);
  },
};

export type { Notification, BrandDetail, ApiResponse };
